export default {
  agreeTitle: 'Accordo sui servizi di marketing tramite "acbuy Affiliate" sul sito web acbuy',
  agreementText:
    'Benvenuto alla registrazione sul sito web acbuy e all\'utilizzo dei suoi servizi di marketing "acbuy Affiliate". Il presente Accordo è stipulato tra i partner di "acbuy Affiliate" (di seguito denominati "Parte B") e acbuy (di seguito denominata "Parte A") (inclusi, ma non limitati a, www.acbuy.com, l\'applicazione mobile di acbuy, ecc., di seguito denominati "Sito web della Parte A") in merito alle questioni relative ai servizi di marketing di "acbuy Affiliate". Prima di utilizzare i servizi di marketing di "acbuy Affiliate" sul sito web acbuy, la Parte B deve leggere attentamente tutti i testi del presente documento, in particolare le parti in grassetto, e cliccando sul pulsante "Ho letto e accetto", la Parte B è considerata aver accettato e acconsentito a conformarsi alle specifiche del presente documento. L\'Accordo costituisce l\'accordo tra la Parte B e acbuy e ha forza giuridica. acbuy ha il diritto di modificare unilateralmente gli articoli del presente documento in base alle proprie esigenze commerciali, e acbuy pubblicherà immediatamente tali modifiche sul sito web della Parte A in caso di modifica degli articoli del presente documento, e la Parte B cesserà immediatamente di utilizzare i servizi di marketing sul canale di "acbuy Affiliate" qualora la Parte B non sia d\'accordo con le modifiche apportate ai testi del presente documento, o altrimenti, la Parte B sarà considerata accettare le modifiche apportate ai testi del presente documento.\nArticolo 1 Definizioni 1. Consumatore: indica il membro acbuy che accede al sito web della Parte A per registrarsi',
  dashboard: 'Pannello di controllo',
  hi: 'Ciao, ',
  inviteFriends: 'Invita amici',
  inviteFriendsTips:
    'Invita amici su acbuy, guadagna di più! Più inviti, più guadagni, senza limiti.',
  inviteFriendsTips1:
    'Invita 3 account attivi per ottenere i diritti di vendita e guadagnare commissioni.',
  totalInvite: 'Numero totale di utenti invitati',
  myTeam: 'Il mio team',
  extractMoney: 'Commissione liquidata',
  noExtractMoney: 'Commissione non liquidata',
  inviteTitle: 'Invita i miei amici',
  copyCode: "Copia il codice d'invito",
  poster: 'Locandina esclusiva',
  myLevel: 'Il mio privilegio ',
  youLevel: 'Il tuo livello attuale',
  commissionRate: 'Tasso di commissione',
  experienceValue: 'Valore esperienza ({num}/{total})',
  levelDesc: 'Descrizione del livello',
  invite: 'Invita',
  revenueDetails: "Dettagli dell'invito",
  registerTime: 'Ora di registrazione',
  inviteType: 'Relazioni affiliate',
  userMail: "E-mail dell'utente",
  bonus: 'Bonus',
  myBonus: 'Il mio bonus',
  myBalance: 'Il mio saldo',
  applyWithdraw: 'Richiesta di prelievo',
  withdrawTips:
    'Suggerimento: A causa delle commissioni di transazione associate al prelievo, si consiglia di prelevare un importo superiore a 500,00 ¥.',
  bank: 'Banca',
  paypalAccount: 'Account PayPal',
  bankAccount: 'Conto bancario',
  bankName: 'Nome della banca',
  withdrawAmount: 'Importo del prelievo ({unit})',
  bonusDetail: 'Dettaglio del bonus',
  directCommission: 'Dettagli della commissione diretta',
  indirectCommission: 'Dettagli della commissione indiretta',
  tradeTime: 'Ora della transazione',
  packNo: 'Numero del pacco',
  actCommission: 'Commissione',
  settlementTime: 'Ora di liquidazione',
  levelName: 'Livello ambasciatore',
  packStatus: 'Stato del pacco',
  directExplain: 'Tasso di commissione',
  indirectExplain: 'Commissione sulle spese di spedizione degli invitati secondari',
  experienceExplain: 'Valore esperienza',
  withdrawRecord: 'Cronologia prelievi',
  withdrawTime: 'Ora del prelievo',
  serialNo: 'N. di serie',
  withdrawStatus: 'Stato del prelievo',
  team: 'Team',
  levelUp: 'Passa al livello superiore',
  teamInfo: 'Informazioni sul team',
  teamNum: 'Numero di utenti nel team',
  monthCommission: 'Commissione stimata per questo mese',
  accCommission: 'Commissione di liquidazione cumulativa',
  teamMember: 'Membro del team',
  promotedMember: 'Membro promosso',
  invitationTime: "Ora dell'invito",
  inviter: 'Invitante',
  promotionTime: 'Ora della promozione',
  IBAN: 'IBAN',
  swiftCode: 'Codice Swift',
  bankAddress: 'Indirizzo della banca',
  setting: 'Impostazioni',
  profile: 'Profilo',
  withdrawMethod: 'Metodo di prelievo',
  myPrerogative: 'Il mio privilegio',
  verifyEmail: 'Verifica la tua e-mail',
  sendCodeTips:
    'Abbiamo inviato un codice di verifica a <strong>{email}</strong>. Inserisci il codice qui sotto per verificare.',
  noGetEmail: 'Non hai ricevuto la tua e-mail?',
  codeErrorTips: 'Errore del codice, riprova',
  resendTime: 'Invia di nuovo il codice ({time}s)',
  or: 'o',
  contactService: 'Contatta il servizio clienti online',
  addMethod: 'Nuovo metodo di prelievo',
  editMethod: 'Modifica il metodo di prelievo',
  rePaypalAccount: "Reinserisci l'account PayPal",
  directInvite: 'Invito diretto',
  indirectInvite: 'Invito indiretto',
  noSameAccount: "L'account è diverso dall'account confermato",
  noAddWithdrawMethod: 'Non hai aggiunto un metodo di prelievo',
  statusEnum: {
    0: 'Da emettere',
    1: 'In fase di emissione',
    2: 'Emissione riuscita',
    3: 'Emissione fallita',
    4: 'Prelievo annullato',
  },
  userDetail: 'Dettaglio utente',
  balance: 'Saldo del conto',
  withdrawMax: 'Importo superiore a 500,00 ¥',
  addPaypalAccount: 'Aggiungi account Paypal',
  addBankAccount: 'Aggiungi conto bancario',
  noPaypalAccount: 'Nessun account Paypal',
  noBankAccount: 'Nessun conto bancario',
  estimated: 'Firmato per',
  notEstimated: 'Non firmato per',
  actual: 'Reale',
  estiamte: 'Stima',
  directRealtion: 'Relazione diretta',
  indirectRealtion: 'Relazione indiretta',
  experienceValueText: 'Valore esperienza',
  relatedParcel: 'Pacco correlato',
  empiricalValue: 'Valore empirico',
  acquiringTime: 'Ora di acquisizione',
  relatedEmail: 'E-mail correlata',
  relatedUsers: 'Utenti correlati',
  balanceDetail: 'Dettaglio del saldo',
  commissionDetail: 'Dettaglio della commissione',
  details: 'Dettagli',
  question1:
    'Una volta che l\'utente invitato completa il pacco, il suo stato verrà aggiornato a "Attivato"',
  question2:
    "L'ordine è stato completato e la commissione è stata trasferita sul tuo conto del saldo",
  question3:
    'Commissione per tutti gli ordini "ricezione non confermata". L\'ordine verrà verificato entro 30-60 giorni, quindi la commissione verrà trasferita sul tuo conto del saldo',
  activatedUser: 'Utente attivato',
  bankTip: "Commissioni di gestione del prelievo: 2% dell'importo del prelievo",
  selectWithdrawMethod: "Seleziona l'account di prelievo",
  currentWithdrawAmount: 'Importo prelevabile attuale',
  modify: 'Modifica',
  bonusBalance: 'Saldo bonus disponibile',
  balanceTips1:
    '1. Pagamento della commissione di liquidazione per il mese precedente il 1° (UTC+8) di ogni mese',
  balanceTips2:
    "2. Dal 1° (UTC+8) al 10 (UTC+8) di ogni mese è la data di prelievo e puoi scegliere di prelevare dal 1° (UTC+8) al 10 (UTC+8). Ti trasferiremo i fondi prima del 20 (UTC+8) e, dopo il trasferimento, ti informeremo dell'esito del trasferimento via e-mail. Allo stesso tempo, puoi controllare le informazioni relative al trasferimento nella cronologia dei prelievi.",
  income: 'Entrata',
  expenditure: 'Spesa',
  commissionSettlement: 'Liquidazione commissioni',
  commissionWithdrawal: 'Prelievo commissioni',
  withdrawalCancellation: 'Annullamento prelievo',
  activeStatus: 'Stato attivo',
  settlePackageNum: 'Quantità pacchi',
  activeTime: 'Ora di attivazione',
  orderTime: 'Ora di invio del pacco',
  orderUser: "Utente dell'ordine",
  actualFreight: 'Pagamento del trasporto effettivo',
  estimatedCommission: 'Commissione stimata',
  withdrawAccount: 'Account di prelievo',
  withdrawType: 'Tipo di prelievo',
  withdrawTypeEnum: {
    2: 'Preleva sul saldo',
    0: 'Preleva sulla banca',
  },
  applyTime: 'Data della richiesta',
  withdrawStatusEnum: {
    0: 'In fase di revisione',
    1: 'In fase di prelievo',
    2: 'Prelievo riuscito',
    3: 'Prelievo rifiutato',
    4: 'Prelievo annullato',
  },
  bankEndNumber: 'Numero finale della carta bancaria',
  cancelWithdraw: 'Annulla prelievo',
  withdrawalDetails: 'Dettagli del prelievo',
  transferVoucher: 'Voucher di trasferimento',
  cancelWithdrawConfirm: 'Conferma annullamento prelievo',
  delPackageHint:
    "Dopo aver confermato l'annullamento del prelievo, l'importo del prelievo corrispondente verrà restituito al saldo della tua commissione",
  withdrawTip:
    'Dal 1° (UTC+8) al 10 (UTC+8) di ogni mese sono i giorni di prelievo e puoi scegliere di prelevare dal 1° (UTC+8) al 10 (UTC+8)',
  hasLogOff: 'Disconnetti',
}
